import { render, staticRenderFns } from "./CodeMessage.vue?vue&type=template&id=3bc325fa&scoped=true&"
import script from "./CodeMessage.vue?vue&type=script&lang=js&"
export * from "./CodeMessage.vue?vue&type=script&lang=js&"
import style0 from "./CodeMessage.vue?vue&type=style&index=0&id=3bc325fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc325fa",
  null
  
)

export default component.exports